import { render, staticRenderFns } from "./SaveProcess.vue?vue&type=template&id=5e954d0e&scoped=true"
import script from "./SaveProcess.vue?vue&type=script&lang=js"
export * from "./SaveProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e954d0e",
  null
  
)

export default component.exports